import React from 'react'
import Style from './index.style'

const CardBox = ({
  image,
  desc,
  title,
  color,
  border = false,
  imageResponsiveMobile = true
}) => {
  return (
    <Style
      imageResponsiveMobile={imageResponsiveMobile}
      color={color}
      border={border}
    >
      <div className="image">
        <img src={image} alt="halojasa/img" loading="lazy" />
      </div>
      <div className="text">
        <div className="title">{title}</div>
        <div className="desc">{desc}</div>
      </div>
    </Style>
  )
}

export default CardBox
